// Temporary landing for AMP group role until Phase 3d builds the real
// AMP read-only events view. Confirms login worked and shows logout.
// Replaced by AmpCalendar.tsx in Phase 3d.

import { LogOut, Users } from 'lucide-react';
import { useAuth } from '../auth';

export function AmpCalendarPlaceholder() {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    window.location.hash = '';
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <div>
            <h1 className="text-xl font-bold text-uif-green-dark">AMP Events</h1>
            <p className="text-xs text-gray-500 -mt-0.5">
              Signed in as {user?.display_name ?? user?.username} · AMP
            </p>
          </div>
          <button
            type="button"
            onClick={handleLogout}
            className="inline-flex items-center gap-1.5 rounded-md border border-gray-300 px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
          >
            <LogOut className="h-4 w-4" />
            Sign out
          </button>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg border border-gray-200 p-8 text-center">
          <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-uif-green/10 text-uif-green-dark mb-3">
            <Users className="h-6 w-6" />
          </div>
          <h2 className="text-lg font-semibold mb-2">AMP view coming soon</h2>
          <p className="text-sm text-gray-600 max-w-md mx-auto">
            You're authenticated and the backend recognizes your AMP role. The
            read-only events calendar showing public + AMP-only events is being
            built in the next phase. For now you can sign out below.
          </p>
        </div>
      </main>
    </div>
  );
}
